import React from "react";
import { Card } from "react-rainbow-components";
import styled from "styled-components";
import breakpoint from "../../assets/breakpoints";
import { ICoupon } from "../../interfaces/coupon";

export const CardCoupon = styled(Card)`
  margin: 0.5rem 0;
`;
export const BubleEdit = styled.div`
  background-color: #fff;
  border-radius: 9999px;
  width: 2rem;
  height: 2rem;
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  transition: all 0.5s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    transition: all 0.5s ease;
    transform: scale(1.5);
  }
`;

export const ContentCoupon = styled.div`
  padding: 1rem;
  border-left: 0.5rem solid #f2f2f2;
  cursor: pointer;
  @media only screen and ${breakpoint.device.xs} {
    max-height: 20vh;
  }

  &.active {
    border-left: 0.5rem solid #123559;
  }

  > h5 {
    display: -webkit-box;
    max-width: 350px;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  > p {
    display: -webkit-box;
    max-width: 350px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0;
    @media only screen and ${breakpoint.device.xs} {
      display: none;
    }
  }
`;

function CardCoupons(
  props: Partial<ICoupon> & {
    isActive?: boolean;
    onClick?: (coupon: ICoupon) => void;
    iconButton?: React.ReactNode;
    onClickButton?: (coupon: ICoupon) => void;
  }
) {
  return (
    <CardCoupon>
      <ContentCoupon
        onClick={() => props.onClick && props.onClick(props as ICoupon)}
        className={props.isActive ? "active" : ""}
      >
        <h5>{props.productName}</h5>
        <BubleEdit
          onClick={() =>
            props.onClickButton && props.onClickButton(props as ICoupon)
          }
        >
          {props.iconButton}
        </BubleEdit>
        <p className="text-h-color">{props.productDescription}</p>
      </ContentCoupon>
    </CardCoupon>
  );
}

export default CardCoupons;
